import React from 'react';
import Loading from 'enl-components/Loading';
import loadable from '../utils/loadable';
import Loadable from "../utils/loadable";

export const DashboardPage = loadable(() => import('./Pages/Dashboard'), {
  fallback: <Loading />,
});
export const Table = loadable(() => import('./Pages/Table/BasicTable'), {
  fallback: <Loading />,
});
export const Form = loadable(() => import('./Pages/Forms/ReduxForm'), {
  fallback: <Loading />,
});
export const LoginFullstack = loadable(
  () => import('./Pages/UsersFullstack/Login'),
  {
    fallback: <Loading />,
  },
);
export const RegisterFullstack = loadable(
  () => import('./Pages/UsersFullstack/Register'),
  {
    fallback: <Loading />,
  },
);
export const ResetPasswordFullstack = loadable(
  () => import('./Pages/UsersFullstack/ResetPassword'),
  {
    fallback: <Loading />,
  },
);
export const Login = loadable(() => import('./Pages/Users/Login'), {
  fallback: <Loading />,
});
export const Register = loadable(() => import('./Pages/Users/Register'), {
  fallback: <Loading />,
});
export const ResetPassword = loadable(
  () => import('./Pages/Users/ResetPassword'),
  {
    fallback: <Loading />,
  },
);
export const ComingSoon = loadable(() => import('./Pages/ComingSoon'), {
  fallback: <Loading />,
});
export const BlankPage = loadable(() => import('./Pages/BlankPage'), {
  fallback: <Loading />,
});
export const NotFound = loadable(() => import('./NotFound/NotFound'), {
  fallback: <Loading />,
});
export const Error = loadable(() => import('./Pages/Error'), {
  fallback: <Loading />,
});
export const Maintenance = loadable(() => import('./Pages/Maintenance'), {
  fallback: <Loading />,
});
export const Parent = loadable(() => import('./Parent'), {
  fallback: <Loading />,
});
export const NotFoundDedicated = loadable(
  () => import('./Pages/Standalone/NotFoundDedicated'),
  {
    fallback: <Loading />,
  },
);

// QR코드 테스트
export const TwoFAQrcode = loadable(() => import('./Pages/Users/TwoFAQrcode'), {
  fallback: <Loading />,
});

export const TwoFANum = loadable(() => import('./Pages/Users/TwoFANum'), {
  fallback: <Loading />,
});

export const ManagerManagement = loadable(
  () => import('./BackOfficeManagement/ManagerManagement/ManagerManagement'),
  {
    fallback: <Loading />,
  },
);

export const UserRegist = loadable(
  () => import('./BackOfficeManagement/ManagerManagement/UserRegist'),
  {
    fallback: <Loading />,
  },
);

export const ManagerInfo = loadable(
  () => import('./BackOfficeManagement/ManagerManagement/ManagerInfo'),
  {
    fallback: <Loading />,
  },
);

export const LogManagement = loadable(
  () => import('./BackOfficeManagement/LogManagement/LogManagement'),
  {
    fallback: <Loading />,
  },
);

export const ConnectionIPManagement = loadable(
  () =>
    import(
      './BackOfficeManagement/ConnectionIPManagement/ConnectionIPManagement'
      ),
  {
    fallback: <Loading />,
  },
);

export const CategoryManagement = loadable(
  () => import('./BackOfficeManagement/CategoryManagement/CategoryManagement'),
  {
    fallback: <Loading />,
  },
);

export const UserInfoManagement = loadable(
  () => import('./Setting/UserInfoManagement/UserInfoManagement'),
  {
    fallback: <Loading />,
  },
);

export const SiteSettings = loadable(
  () => import('./Setting/SiteSettings/SiteSettings'),
  {
    fallback: <Loading />,
  },
);

export const PerplayUserManagement = loadable(
  () => import('./UserManagement/PerplayUserManagement/PerplayUserManagement'),
  {
    fallback: <Loading />,
  },
);

export const PerplayUserInfo = loadable(
  () => import('./UserManagement/PerplayUserManagement/PerplayUserInfo'),
  {
    fallback: <Loading />,
  },
);

export const PerplayUseLog = loadable(
  () => import('./UserManagement/PerplayUserManagement/UseLog/UseLogMain'),
  {
    fallback: <Loading />,
  },
);

export const CampaignGames = loadable(
  () => import('./AppManagement/Game/CampaignGames/CampaignGames'),
  {
    fallback: <Loading />,
  },
);

export const GameInfoCampaign = loadable(
  () => import('./AppManagement/Game/CampaignGames/GameInfoCampaign'),
  {
    fallback: <Loading />,
  },
);

export const RegistGameCampaign = loadable(
  () => import('./AppManagement/Game/CampaignGames/registGameCampaign'),
  {
    fallback: <Loading />,
  },
);

export const RecommendedGame = loadable(
  () => import('./AppManagement/Campaign/RecommendedGame/RecommendedGame'),
  {
    fallback: <Loading />,
  },
);

export const NewCampaign = loadable(
  () => import('./AppManagement/Campaign/RecommendedGame/newCampaign'),
  {
    fallback: <Loading />,
  },
);

export const CampaignInfo = loadable(
  () => import('./AppManagement/Campaign/RecommendedGame/campaignInfo'),
  {
    fallback: <Loading />,
  },
);

export const SpecialGame = loadable(
  () => import('./AppManagement/Campaign/SpecialGame/SpecialGame'),
  {
    fallback: <Loading />,
  },
);

export const NewSpecialCampaign = loadable(
  () => import('./AppManagement/Campaign/SpecialGame/newCampaign'),
  {
    fallback: <Loading />,
  },
);

export const CampaignSpecialInfo = loadable(
  () => import('./AppManagement/Campaign/SpecialGame/campaignInfo'),
  {
    fallback: <Loading />,
  },
);

export const Banner = loadable(
  () => import('./EventManagement/Banner/banner'),
  {
    fallback: <Loading />,
  },
);

export const NewBanner = loadable(
  () => import('./EventManagement/Banner/newBanner'),
  {
    fallback: <Loading />,
  },
);

export const BannerInfo = loadable(
  () => import('./EventManagement/Banner/bannerInfo'),
  {
    fallback: <Loading />,
  },
);

export const Notice = loadable(
    () => import('./EventManagement/Notice/notice'),
    {
        fallback: <Loading />,
    }
)

export const NoticeCreate = loadable(
    () => import('./EventManagement/Notice/create'),
    {
        fallback: <Loading />,
    }
)

export const NoticeUpdate = loadable(
    () => import('./EventManagement/Notice/update'),
    {
        fallback: <Loading />,
    }
)

export const Event = loadable(
    () => import('./EventManagement/Event/event'),
    {fallback : <Loading/>}
);

export const EventCreate = loadable(
    () => import('./EventManagement/Event/create'),
    {fallback : <Loading/>}
)

export const EventUpdate = loadable(
    () => import('./EventManagement/Event/update'),
    {fallback : <Loading/>}
)



export const MiningEvent = loadable(
  () => import('./EventManagement/BalanceEvent/Mining/MiningMain'),
  {
    fallback: <Loading />,
  },
);

export const MiningEventRegist = loadable(
  () => import('./EventManagement/BalanceEvent/Mining/miningRegist'),
  {
    fallback: <Loading />,
  },
);

export const MiningEventInfo = loadable(
  () => import('./EventManagement/BalanceEvent/Mining/miningInfo'),
  {
    fallback: <Loading />,
  },
);

export const FreeNFTEvent = loadable(
  () => import('./EventManagement/NewUserEvent/FreeNFT/FreeNFTMain'),
  {
    fallback: <Loading />,
  },
);

export const FreeNFTEventRegist = loadable(
  () => import('./EventManagement/NewUserEvent/FreeNFT/freeNFTRegist'),
  {
    fallback: <Loading />,
  },
);

export const FreeNFTEventInfo = loadable(
  () => import('./EventManagement/NewUserEvent/FreeNFT/freeNFTInfo'),
  {
    fallback: <Loading />,
  },
);

export const InvitationEvent = loadable(
  () => import('./EventManagement/NewUserEvent/Invitation/InvitationMain'),
  {
    fallback: <Loading />,
  },
);

export const InvitationEventRegist = loadable(
  () => import('./EventManagement/NewUserEvent/Invitation/invitationRegist'),
  {
    fallback: <Loading />,
  },
);

export const InvitationEventInfo = loadable(
  () => import('./EventManagement/NewUserEvent/Invitation/invitationInfo'),
  {
    fallback: <Loading />,
  },
);

export const StarterPackEvent = loadable(
  () =>
    import('./EventManagement/UserActivityEvent/StarterPack/StarterPackMain'),
  {
    fallback: <Loading />,
  },
);

export const StarterPackEventRegist = loadable(
  () =>
    import('./EventManagement/UserActivityEvent/StarterPack/starterPackRegist'),
  {
    fallback: <Loading />,
  },
);

export const StarterPackEventInfo = loadable(
  () =>
    import('./EventManagement/UserActivityEvent/StarterPack/starterPackInfo'),
  {
    fallback: <Loading />,
  },
);

export const DrawItemMain = loadable(
  () => import('./EventManagement/UserActivityEvent/DrawItem/DrawItemMain'),
  {
    fallback: <Loading />,
  },
);

export const DrawItemRegist = loadable(
  () => import('./EventManagement/UserActivityEvent/DrawItem/drawItemRegist'),
  {
    fallback: <Loading />,
  },
);

export const DrawItemInfo = loadable(
  () => import('./EventManagement/UserActivityEvent/DrawItem/drawItemInfo'),
  {
    fallback: <Loading />,
  },
);

export const WalletDashborad = loadable(
  () => import('./walletManagement/Dashboard/WalletDashborad'),
  {
    fallback: <Loading />,
  },
);

export const Automation = loadable(
  () =>
    import('./walletManagement/tokenManagement/Automation/AutomationSetting'),
  {
    fallback: <Loading />,
  },
);

export const XperPublish = loadable(
  () => import('./walletManagement/tokenManagement/XperPublish/XperPublish'),
  {
    fallback: <Loading />,
  },
);

export const ServerStatusMonitoring = loadable(
  () => import('./walletManagement/ServerStatusMonitoring/Monitoring'),
  {
    fallback: <Loading />,
  },
);

export const RealTimeData = loadable(
  () => import('./AppManagement/FixAppData/RealTimeData/RealTimeData'),
  {
    fallback: <Loading />,
  },
);

export const MessageManagement = loadable(
  () => import('./UserManagement/MessageManagement/MessageMain'),
  {
    fallback: <Loading />,
  },
);

export const NewMessage = loadable(
  () => import('./UserManagement/MessageManagement/newMessage'),
  {
    fallback: <Loading />,
  },
);

export const PartnerManagement = loadable(
  () => import('./BackOfficeManagement/PartnerManagement/PartnerManagement'),
  {
    fallback: <Loading />,
  },
);

export const RegistNewPartner = loadable(
  () => import('./BackOfficeManagement/PartnerManagement/registNewPartner'),
  {
    fallback: <Loading />,
  },
);

export const PartnerDetails = loadable(
  () => import('./BackOfficeManagement/PartnerManagement/partnerDetails'),
  {
    fallback: <Loading />,
  },
);

export const MaintenanceMain = loadable(
  () => import('./AppManagement/Maintenance/MaintenanceMain'),
  {
    fallback: <Loading />,
  },
);

export const MaintenanceRegist = loadable(
  () => import('./AppManagement/Maintenance/maintenanceRegist'),
  {
    fallback: <Loading />,
  },
);

export const MaintenanceInfo = loadable(
  () => import('./AppManagement/Maintenance/maintenanceInfo'),
  {
    fallback: <Loading />,
  },
);

export const WhiteListApps = loadable(
  () => import('./AppManagement/WhiteListApps/WhiteListApps'),
  {
    fallback: <Loading />,
  },
);

export const AppVersion = loadable(
  () => import('./AppManagement/AppVersion/AppVersion'),
  {
    fallback: <Loading />,
  },
);

export const StringTableFetch = loadable(
  () =>
    import(
      './AppManagement/AppResourceFetch/StringTableFetch/StringTableFetch'
      ),
  {
    fallback: <Loading />,
  },
);

export const ItemDB = loadable(
  () => import('./AppManagement/FixAppData/ItemDB/ItemDB'),
  {
    fallback: <Loading />,
  },
);

export const NFT = loadable(
  () => import('./AppManagement/FixAppData/NFT/NFTMain'),
  {
    fallback: <Loading />,
  },
);

export const GenerateItem = loadable(
  () => import('./AppManagement/FixAppData/NFT/GenerateNFT'),
  {
    fallback: <Loading />,
  },
);

export const WelcomePage = loadable(() => import('./Pages/WelcomePage'), {
  fallback: <Loading />,
});

export const GameSessionLogMain = loadable(
  () => import('./LogManagement/Perplay/GameSession/GameSessionLogMain'),
  {
    fallback: <Loading />,
  },
);

export const SpecialBoxLogMain = loadable(
  () => import('./LogManagement/Perplay/SpecialBox/SpecialBoxLogMain'),
  {
    fallback: <Loading />,
  },
);

export const PowerChargeLogMain = loadable(
  () => import('./LogManagement/Perplay/PowerCharge/PowerChargeLogMain'),
  {
    fallback: <Loading />,
  },
);

export const LevelUpLogMain = loadable(
  () => import('./LogManagement/Perplay/LevelUp/LevelUpLogMain'),
  {
    fallback: <Loading />,
  },
);

export const BreedLogMain = loadable(
  () => import('./LogManagement/Perplay/Breed/BreedLogMain'),
  {
    fallback: <Loading />,
  },
);

export const EvolveLogMain = loadable(
  () => import('./LogManagement/Perplay/Evolve/EvolveLogMain'),
  {
    fallback: <Loading />,
  },
);

export const WalletTransactionLogMain = loadable(
  () =>
    import(
      './LogManagement/Perplay/WalletTransaction/WalletTransactionLogMain'
      ),
  {
    fallback: <Loading />,
  },
);

export const NFTTransactionLogMain = loadable(
  () => import('./LogManagement/Perplay/NFTTransaction/NFTTransactionLogMain'),
  {
    fallback: <Loading />,
  },
);

export const InventoryTransactionLogMain = loadable(
  () =>
    import(
      './LogManagement/Perplay/InventoryTransaction/InventoryTransactionLogMain'
      ),
  {
    fallback: <Loading />,
  },
);

export const MarketTransactionLogMain = loadable(
  () =>
    import(
      './LogManagement/Perplay/MarketTransaction/MarketTransactionLogMain'
      ),
  {
    fallback: <Loading />,
  },
);

export const GemSocketLogMain = loadable(() =>
    import('./LogManagement/Perplay/GemSocket/GemSocketLogMain'), {
    fallback: <Loading />,
  },
)

export const ResetStatsLogMain = loadable(() =>
    import('./LogManagement/Perplay/ResetStats/ResetStatsLogMain'), {
    fallback: <Loading />,
  }
)

export const LoginLogMain = loadable(
  () => import('./LogManagement/User/Login/LoginLogMain'),
  {
    fallback: <Loading />,
  },
);

export const SessionLogMain = loadable(
  () => import('./LogManagement/User/Session/SessionLogMain'),
  {
    fallback: <Loading />,
  },
);

export const HolderLogMain = loadable(
  () => import('./LogManagement/User/Holder/HolderLogMain'),
  {
    fallback: <Loading />,
  },
);

export const NFTMain = loadable(
  () => import('./Monitoring/Information/NFT/NFTMain'),
  {
    fallback: <Loading />,
  },
);

export const WalletInfoMain = loadable(
  () => import('./Monitoring/Information/Wallet/WalletInfoMain'),
  {
    fallback: <Loading />,
  },
);

export const BridgeWalletInfoMain = loadable(
    () => import('./Monitoring/Information/Wallet/BridgeWalletInfoMain'),
    {
        fallback: <Loading />,
    },
);

export const SummaryMain = loadable(
  () => import('./Monitoring/Statistics/Summary/SummaryMain'),
  {
    fallback: <Loading />,
  }
)

export const FinanceMain = loadable(() =>
    import('./Monitoring/Statistics/Finance/FinanceMain'), {
    fallback: <Loading />,
  }
)

export const ItemBoxLogMain = loadable(
    () => import('./LogManagement/Perplay/ItemBox/ItemBoxLogMain'),
    {
        fallback: <Loading />,
    },
);

export const RaffleMain = loadable(
    () => import('./EventManagement/UserActivityEvent/Raffle/raffleMain'),
    {
        fallback: <Loading />,
    },
);

export const RaffleRegist = loadable(
    () => import('./EventManagement/UserActivityEvent/Raffle/raffleRegist'),
    {
        fallback: <Loading />,
    },
);

export const RaffleInfo = loadable(
    () => import('./EventManagement/UserActivityEvent/Raffle/raffleInfo'),
    {
        fallback: <Loading />,
    },
);

export const SafetyCodeLogMain = loadable(
    () => import('./LogManagement/Perplay/SafetyCode/SafetyCodeLogMain'),
    {
        fallback: <Loading />,
    },
);

export const ItemShopMain = loadable(
    () => import('./AppManagement/FixAppData/ItemShop/itemShop'),
    {
        fallback: <Loading />,
    }
);

export const ItemShopProductRegist = loadable(
    () => import('./AppManagement/FixAppData/ItemShop/productRegist'),
    {
        fallback: <Loading />,
    }
);

export const ItemShopProductInfo = loadable(
    () => import('./AppManagement/FixAppData/ItemShop/productInfo'),
    {
        fallback: <Loading />,
    }
);

export const GoogleStoreMain = loadable(
    () => import('./AppManagement/FixAppData/GoogleStore/googleStore'),
    {
        fallback : <Loading/>
    });

export const GoogleStoreProductRegist = loadable(
    () => import('./AppManagement/FixAppData/GoogleStore/productRegist'),
    {
        fallback : <Loading/>
    });

export const GoogleStoreProductInfo = loadable(
    () => import('./AppManagement/FixAppData/GoogleStore/productInfo'),
    {
        fallback : <Loading/>
    });

export const ItemShopLogMain = loadable(
    () => import('./LogManagement/Perplay/ItemShop/ItemShopLogMain'),
    {
        fallback: <Loading />,
    },
);

export const GoogleStorePurchaseLogList = loadable(
  () => import("./LogManagement/Perplay/GoogleStore/GoogleStorePurchaseLogList"),
  {
    fallback : <Loading/>,
  }
)

export const PilotEquipLogList = loadable(
    () => import("./LogManagement/Perplay/Pilot/PilotEquipLog"),
    {
        fallback: <Loading />,
    }
)

export const PilotSkillChangeLogList = loadable(
    () => import("./LogManagement/Perplay/Pilot/PilotSkillChangeLog"),
    {
        fallback: <Loading />,
    }
)

export const PilotDisassembleLogList = loadable(
    () => import("./LogManagement/Perplay/Pilot/PilotDisassembleLog"),
    {
        fallback: <Loading />,
    }
)

export const PilotPromotionLogList = loadable(
    () => import("./LogManagement/Perplay/Pilot/PilotPromotionLog"),
    {
        fallback: <Loading />,
    }
)
